import React, { useContext,ElementType, useEffect } from 'react'
import SpDropdown from '@/components/atoms/SpDropDown'
import styles from './styles.module.css' 
import { DealerDetailsContext } from '@/context/dealerDetailsContext'
import { FormHelperText, OutlinedInput,InputBaseComponentProps } from '@material-ui/core'
import { AutoValidateAddressFields } from '../AutoValidateAddressFields'
import { AddressValues } from '@/types/v2/address'
import { Controller } from 'react-hook-form'
import { PLACEHOLDERS } from '@/utils/constants'
import { PhoneMaskCustom } from '@/components/molecules/PhoneMaskCustom'
import { useManufacturers } from '@/hooks/useManufacturers'
import { ErrorOutline } from '@material-ui/icons'
import useUserType from '@/hooks/useUserType'

import PhoneIcon from '@/public/images/icons/phone-icon.svg'
import EmailIcon from '@/public/images/icons/email-icon.svg'
import { useGetDealerCompanies } from '@/hooks/useGetDealerCompanies'
import AutoCompleteWithAddition from '@/components/organisms/DealerPopup'

function ModalCompanyDealerSection() {
    const {formState,setValue,watch,register,control,setError,getValues} =useContext(DealerDetailsContext)
    const {errors}=formState 

    const { manufacturers } = useManufacturers() 
    
    // register('company_name', {
    //     required: {
    //       value: true,
    //       message: 'Company Name is required',
    //     }
    //   }) 

    const handleSetFormValues = ({
        address_apt,
        city,
        street,
        state_id,
        zip_code,
        county,
        latitude,
        state_selected = null,
        longitude,
      }: AddressValues) => {
        const noErrors = Object.keys(errors).length === 0 
        setValue('company_street', street, { shouldValidate: true })
        setValue('company_city', city, { shouldValidate: true })
        setValue('company_state_id', state_id, { shouldValidate: true })
        setValue('company_zip_code', zip_code, { shouldValidate: true })
        setValue('state_name_selected', state_selected)
        setValue('company_address_apt', address_apt)
        setValue('company_county', county)
        setValue('company_latitude', latitude)
        setValue('company_longitude', longitude) 
        if (noErrors) {
          window.scrollTo(0, document.body.scrollHeight)
        }
      }

    const manufacturerId = watch('manufacturerIdSelected')
    const dealerCompany = watch('company')  
    const {dealerCompanies} = useGetDealerCompanies(manufacturerId)
 
    const validatePhoneNumber = (value) => {
        const strippedPhoneNumber = value.replace(/\D/g, ''); 
    
        if (strippedPhoneNumber.length !== 10) {
          setError('company_phone', {
            type: 'manual',
            message: 'Phone number must have 10 digits'
          });
          return 'Phone number must have 10 digits'; 
        }
    
        return true;
      };

    useEffect(() => {
        if (dealerCompanies.length > 0) {
            setValue('companyId', dealerCompany); 
        }
      }, [dealerCompanies]);

    useEffect(() => {
        const selectedCompany = dealerCompanies.find(company => company.id === dealerCompany?.id);   
        if (selectedCompany&&(dealerCompany?.id>0)) {
          setValue('companyId', selectedCompany?.id);
          setValue('company_name', selectedCompany?.name);
          setValue('company_email', selectedCompany?.email);
          setValue('company_phone', selectedCompany?.phone);
          setValue('company_street', selectedCompany?.address1);
          setValue('company_city', selectedCompany?.city);
          setValue('company_state_id', selectedCompany?.state_id);
          setValue('company_zip_code', selectedCompany?.zip);
          setValue('company_address_apt', selectedCompany?.address_apt); 
          setValue('company_county',selectedCompany?.county)
        }
        else{
            setValue('companyId', 0);
            setValue('company_email', "");
            setValue('company_phone', "");
            setValue('company_street', "");
            setValue('company_city', "");
            setValue('company_state_id', "");
            setValue('company_zip_code', "");
            setValue('company_address_apt', ""); 
            setValue('company_county',"")
        }
    }, [dealerCompany, dealerCompanies]);

    const streetWatched = watch('company_street')
    const cityWatched = watch('company_city')
    const stateIdWatched = watch('company_state_id')
    const zipWatched = watch('company_zip_code')
    const extraInfoWatched = watch('company_address_apt')   
    const countyWatched = watch('company_county')

    register('company_street', {
        required: {
          value: true,
          message: 'Company Address is required',
        }
      }) 

    return (
   
    <div className={styles.dealerForm}>
        <h4 className={styles.headerSubtitle}>Dealer Company&#39;s information</h4>  
        <AutoCompleteWithAddition
        options={dealerCompanies}
        name="company"
        title="Company"
        placeholder="Select or Add a Company"
        />  
        {/* {Boolean(errors?.company_name) && (
            <FormHelperText error className="input-helper-text">
                {errors.company_name.message}
            </FormHelperText>
        )} */}

        <div className={styles.company_fields}>
            <AutoValidateAddressFields 
                internalFormId={""}
                errorMessage={errors?.addressCompleted?.message}
                // initialButtonText={hasDealerAddress ? 'Edit Address' : 'Add Address'}
                setFormValues={handleSetFormValues}
                previousValues={{
                    street: streetWatched,
                    city: cityWatched,
                    extraInfo: extraInfoWatched,
                    stateId: stateIdWatched,
                    zipCode: zipWatched,
                    county:countyWatched
                }} 
                watch={watch}
                setValue={setValue}
                getValues={getValues}
                />
        </div>
        {Boolean(errors?.company_street) && (
            <FormHelperText error className="input-helper-text">
                {errors.company_street.message}
            </FormHelperText>
        )}

        <OutlinedInput
             {...register('company_phone', {
                required: {
                    value: true,
                    message: 'Phone Number is required',
                }, 
                validate:{
                    validateRequired: (value) => !!value.trim() || 'Phone Number is required' ,
                    validPhoneNumber: validatePhoneNumber
                }

            })} 
            fullWidth
            className={styles.company_fields}
            placeholder={PLACEHOLDERS.phoneNumber}
            error={Boolean(errors?.company_phone)}
            inputComponent={PhoneMaskCustom as ElementType<InputBaseComponentProps>}
            startAdornment={<img src={PhoneIcon.src} />} 
            endAdornment={errors.company_phone ? <ErrorOutline style={{ color: '#f44336' }} /> : ''}/>
        {Boolean(errors?.company_phone) && (
            <FormHelperText error className="input-helper-text">
                {errors.company_phone.message}
            </FormHelperText>
        )}

        <OutlinedInput
            {...register('company_email', {
                required: {
                    value: true,
                    message: 'Email Id is required',
                },
                pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: 'Invalid email address',
                  },
                validate: (value) => !!value.trim() || 'Email Id is required' 
            })} 
            fullWidth
            className={styles.company_fields}
            placeholder={PLACEHOLDERS.email}
            type="email"
            error={Boolean(errors?.company_email)}
            endAdornment={errors.company_email ? <ErrorOutline style={{ color: '#f44336' }} /> : ''}
            startAdornment={<img src={EmailIcon.src} />} />
        {Boolean(errors?.company_email) && (
            <FormHelperText error className="input-helper-text">
                {errors.company_email.message}
            </FormHelperText>
        )}

        <div className={`${styles.company_fields} ${styles.manufacturer}`}>
            <Controller
                name="manufacturerIdSelected"
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <>
                        <SpDropdown
                            {...field}
                            className={styles.manufacturer_dd}
                            valueKeyName="id"
                            labelKeyName="name"
                            placeholder="Select A Manufacturer"
                            name="manufacturerIdSelected"
                            isDisabled={true}
                            options={manufacturers}
                            value={field.value === 'default' ? '' : field.value}
                            reference={register('manufacturerIdSelected').ref}
                            error={Boolean(error?.message)} 
                            zIndex={1500}/>

                        {Boolean(error?.message) && (
                            <FormHelperText error className="input-helper-text">
                                {error.message}
                            </FormHelperText>
                        )}
                    </>
                )} />
        </div>
    </div>
    
  )
}

export default ModalCompanyDealerSection
